import React from "react";
import PropTypes from "prop-types";
import { PostPropType } from "components/blog/proptypes";
import BlogEntryTeaser from "components/blog/blogentryteaser";
import Pagination from "components/blog/pagination";
import Styles from "./global.scss";

const SearchResults = (props) => {
    const { posts } = props;

    const styles = Styles;
    return (
        <div className="blog__results">
            <style jsx>{styles}</style>
            <div className="results__items">
                {posts &&
                    posts.map((p) => <BlogEntryTeaser layout="thumbnail" key={p.id} post={p} />)}
            </div>

            {/* Pagination */}
            <Pagination {...props} />
        </div>
    );
};

SearchResults.propTypes = {
    posts: PropTypes.arrayOf(PostPropType).isRequired,
    total: PropTypes.number.isRequired,
    skip: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    query: PropTypes.string,
    category: PropTypes.string,
    categoryName: PropTypes.string
};

SearchResults.defaultProps = {
    query: null,
    category: null,
    categoryName: null
};

export default SearchResults;
